import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getScheduleUpdatedBySelector } from '../../../redux/slices/ganttSlice.js';
import ModalSystem from '../../DesignSystem/ModalSystem/ModalSystem';
import ButtonSystem from '../../DesignSystem/ButtonSystem/ButtonSystem';
import { Colors } from '../../../constants/colors.constants.js';
import { WarningRedIcon } from '../../../icons/index.js';
import './GanttOutdatedConfirmationModal.scss';
import { type Member } from '../../../assets/js/collaborative_space';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';
import { trackingEvent } from '../../../analytics';

interface GanttOutdatedConfirmationModalProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  onSave: () => void;
  scheduleUpdatedBy: {
    member: Member | null;
    updatedAt: Date | null;
  };
}
const GanttOutdatedConfirmationModal = ({
  isVisible,
  setIsVisible,
  onSave,
  scheduleUpdatedBy
}: GanttOutdatedConfirmationModalProps) => {
  const { t } = useTranslation();

  const handleSave = () => {
    onSave();
    setIsVisible(false);
    trackingEvent(
      'schedule_save_overwrite_confirmed',
      {
        ...getBasicAmplitudEventProperties()
      },
      AMPLITUDE_SERVICE
    );
  };

  return (
    <ModalSystem
      visible={isVisible}
      setVisible={setIsVisible}
      theme="dark"
      showTitle={true}
      title={t('master_plan.schedule_out_of_date_modal_title')}
      width={375}
      showIconTitle={true}
      iconTitle={
        <WarningRedIcon
          color={Colors.RED}
          className="gantt-outdated-confirmation-modal__icon"
        />
      }
      centered={true}>
      <div className="gantt-outdated-confirmation-modal">
        <div className="gantt-outdated-confirmation-modal__message">
          {t('master_plan.schedule_out_of_date_modal_message', {
            user: scheduleUpdatedBy.member?.profileData.fullName
          })}
        </div>
        <div className="gantt-outdated-confirmation-modal__actions">
          <ButtonSystem type="secondary" onClick={() => setIsVisible(false)}>
            {t('cancel')}
          </ButtonSystem>
          <ButtonSystem
            className="gantt-outdated-confirmation-modal__save-button"
            onClick={handleSave}>
            {t('master_plan.schedule_out_of_date_modal_save_anyway')}
          </ButtonSystem>
        </div>
      </div>
    </ModalSystem>
  );
};

const mapStateToProps = (state) => ({
  scheduleUpdatedBy: getScheduleUpdatedBySelector(state)
});

export default connect(mapStateToProps)(GanttOutdatedConfirmationModal);
